export const images = {
  icon: {
    pencil: '/assets/images/svg/icon-1.svg',
    camera: '/assets/images/svg/icon-2.svg',
    edit: '/assets/images/svg/icon-3.svg',
    label: '/assets/images/svg/icon-4.svg',
    track: '/assets/images/svg/icon-5.svg',
    bag: '/assets/images/svg/bag.svg',
    box: '/assets/images/svg/box.svg',
    tote: '/assets/images/svg/tote.svg',
    downloadColor: '/assets/images/svg/download-color.svg',
    trash: '/assets/images/svg/trash.svg'
  }
}
